import "./ContactUs.module.css";
import Header from "@/reusable_sections/Header";
import ContactInformation from "./sections/ContactInformation";
import ScheduleACall from "./sections/ScheduleACall";
import GetStarted from "./sections/GetStarted";
import FooterInformation from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <Header />
      <ContactInformation />
      <ScheduleACall />
      <GetStarted />
      <FooterInformation />
    </div>;
}